import styled from 'styled-components/macro';

import { applyStyleModifiers } from 'styled-components-modifiers';

const TAG_MODIFIERS = {
  light: ({ theme }) => `
    background-color: ${theme.colors.grey};
  `,
  primary: ({ theme }) => `
    background-color: ${theme.colors.primary};
  `,
};

const Tag = styled.div`
  display: inline-flex;
  padding: 4px 6px;
  background-color: ${props => (props.backgroundColor ? props.backgroundColor : props.theme.colors.blue)};
  text-transform: uppercase;
  font-size: 11px;
  color: white;
  ${applyStyleModifiers(TAG_MODIFIERS)};
`;

export default Tag;
